import {Service} from './service';
import {Partner} from './partner/partner';
import {Chat} from './chat';
import {Document} from './document';
import {ProjectContainer} from './project-container';
import {ProjectMemberRef} from '../utils/project-member-utils';
import {Observable} from 'rxjs';

// Todo: Actualizar o eliminar segun los verdaderos objetos de la BD

export interface Project {
  id: number;
  reference: string;
  name: string;
  startPlanDate?: string;
  endPlanDate?: string;
  chatId: number;
  operationExecutiveId?: number;              // ← MANTENER (compatibilidad con datos históricos)
  deputyProjectManagerId?: number;            // ← MANTENER
  administrationAgentId?: number;             // ← MANTENER (rol fuera de uso, no se muestra)
  commercialExecutiveId?: number;             // ← MANTENER
  operationsManagerId?: number;               // ← MANTENER
  // Listas de titulares por rol. El backend las ACEPTA al guardar pero no las devuelve:
  // al leer, los titulares llegan en `projectMembers`. Si están presentes es porque la
  // pantalla las escribió al editar.
  operationExecutiveIds?: number[];
  deputyProjectManagerIds?: number[];
  commercialExecutiveIds?: number[];
  operationsManagerIds?: number[];
  controllerIds?: number[];                   // Controller no tiene columna escalar detrás
  /** Titulares servidos por el backend, un elemento por persona y rol. */
  projectMembers?: ProjectMemberRef[];
  isActive: boolean;
  status: string
  totalPlanned?: number | null;
  priceId?: string; // Este es el ID de la cotizacion de Odoo (Revisar si es string o number al final)
  odooSaleOrderLineId?: number;
  odooSaleOrderOptionId?: number;
  partnerId?: number;              // ← MANTENER (compatibilidad con datos históricos)
  partnerIds?: number[];           // ← NUEVO: lista de IDs de partners múltiples
  partners?: Partner[];            // ← NUEVO: lista de objetos Partner (del backend)
  services?: Service[];
  operationExecutive?: Partner;
  deputyProjectManager?: Partner;
  administrationAgent?: Partner;
  commercialExecutive?: Partner;
  operationsManager?: Partner;
  partner?: Partner;
  chat?: Chat;
  documents?: Document[];
  projectContainers?: ProjectContainer[];
  odooEntityId?: number;
  driveLink?: string;
}

export interface ProjectCreate {
  name: string;
  priceId?: number;
  partnerId?: number;        // ← MANTENER (compatibilidad hacia atrás)
  partnerIds?: number[];     // ← NUEVO: lista de partners múltiples
  operationExecutiveId?: number;        // ← MANTENER (compatibilidad hacia atrás)
  deputyProjectManagerId?: number;      // ← MANTENER
  administrationAgentId?: number;       // ← MANTENER (rol fuera de uso)
  commercialExecutiveId?: number;       // ← MANTENER
  operationsManagerId?: number;         // ← MANTENER
  operationExecutiveIds?: number[];     // ← NUEVO: varios titulares por rol
  deputyProjectManagerIds?: number[];   // ← NUEVO
  commercialExecutiveIds?: number[];    // ← NUEVO
  operationsManagerIds?: number[];      // ← NUEVO
  controllerIds?: number[];             // ← NUEVO
  startPlanDate?: string;
  endPlanDate?: string;
  status?: string;
  reference?: string;
}

export interface ProjectServiceRequests {
  project: Observable<any>,
  projectDocuments: Observable<any>,
  containers: Observable<any>,
  service?: Observable<any>,
  serviceDocuments?: Observable<any>,
  template?: Observable<any>,
  flow?: Observable<any>,
}
